<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="tile">
  <div class="d-flex justify-content-center zero-text p-huge-med">{{ 'guided-tour.teaser.headline' | transloco }}</div>
  <div class="d-flex justify-content-center zero-text p-small-reg mt-2 mb-5">
    {{ 'guided-tour.teaser.text' | transloco }}
  </div>
  <div class="d-flex justify-content-center mb-5">
    <div class="d-block d-lg-flex justify-content-between gap-large">
      <div class="app-teaser">
        <div class="app-teaser-container zero-surface grey-800 b-r-8 mb-3 d-flex justify-content-center align-items-center">
          <img src="assets/img/guided-tour/app-preview.svg" alt="ZERO App Preview" />
        </div>
        <div class="zero-text p-base-med mb-2 d-flex justify-content-center">
          {{ 'guided-tour.teaser.apps.zero.headline' | transloco }}
        </div>
        <div class="zero-text p-small-reg text-center mb-2">
          {{ 'guided-tour.teaser.apps.zero.text' | transloco }}
        </div>
        <div class="d-block d-lg-flex justify-content-between gap text-center">
          <a class="d-block mb-2 mb-lg-0" [href]="ZERO_APP_APPLE_URL" target="_blank" rel="noopener noreferrer nofollow">
            <img src="assets/img/guided-tour/zero-app-app-store.svg" alt="ZERO App Store" />
          </a>
          <a class="d-block mb-5 mb-lg-0" [href]="ZERO_APP_GOOGLE_URL" target="_blank" rel="noopener noreferrer nofollow">
            <img src="assets/img/guided-tour/zero-app-google-play.svg" alt="ZERO App Google Play Store" />
          </a>
        </div>
      </div>
      <div class="app-teaser">
        <div class="app-teaser-container zero-surface grey-800 b-r-8 mb-3 d-flex justify-content-center align-items-center">
          <img src="assets/img/guided-tour/tan-app-preview.svg" alt="ZERO TAN App Preview" />
        </div>
        <div class="zero-text p-base-med mb-2 d-flex justify-content-center">
          {{ 'guided-tour.teaser.apps.tan.headline' | transloco }}
        </div>
        <div class="zero-text p-small-reg text-center mb-2">
          {{ 'guided-tour.teaser.apps.tan.text' | transloco }}
        </div>
        <div class="d-block d-lg-flex justify-content-between gap text-center">
          <a class="d-block mb-2 mb-lg-0" [href]="ZERO_TAN_APP_APPLE_URL" target="_blank" rel="noopener noreferrer nofollow">
            <img src="assets/img/guided-tour/zero-tan-app-app-store.svg" alt="ZERO TAN App Store" />
          </a>
          <a class="d-block mb-5 mb-lg-0" [href]="ZERO_TAN_APP_GOOGLE_URL" target="_blank" rel="noopener noreferrer nofollow">
            <img src="assets/img/guided-tour/zero-tan-app-google-play.svg" alt="ZERO TAN App Google Play Store" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-center mb-3">
    <div class="zero-text p-bigger-med">{{ 'guided-tour.teaser.next.headline' | transloco }}</div>
  </div>
  <div class="d-flex gap mb-3">
    @if (savingsPlanFacade.hasOnboardingSavingsPlans$ | async) {
      <div class="circle zero-surface secondary-500">
        <web-design-system-icon name="check" color="white" />
      </div>
    } @else {
      <div class="circle zero-surface primary-400">
        <web-design-system-icon name="pig" color="white" />
      </div>
    }
    <div>
      <div class="zero-text p-base-med">{{ 'guided-tour.teaser.next.savings-plan.headline' | transloco }}</div>
      <div class="zero-text p-small-reg">
        @if (savingsPlanFacade.hasOnboardingSavingsPlans$ | async) {
          {{ 'guided-tour.teaser.next.savings-plan.has-savings-plan.prefix' | transloco
          }}<a class="zero-text link" [routerLink]="SAVINGS_PLANS_URL">{{ 'guided-tour.teaser.next.savings-plan.link' | transloco }}</a
          >{{ 'guided-tour.teaser.next.savings-plan.has-savings-plan.suffix' | transloco }}
        } @else {
          {{ 'guided-tour.teaser.next.savings-plan.no-savings-plan.prefix' | transloco
          }}<a class="zero-text link" [routerLink]="ONBOARDING_SAVINGS_PLAN_JOURNEY_URL">{{
            'guided-tour.teaser.next.savings-plan.link' | transloco
          }}</a
          >{{ 'guided-tour.teaser.next.savings-plan.no-savings-plan.suffix' | transloco }}
        }
      </div>
    </div>
  </div>
  <div class="d-flex gap mb-3">
    @if ((watchlistFacade.watchlist$ | async)?.length) {
      <div class="circle zero-surface secondary-500">
        <web-design-system-icon name="check" color="white" />
      </div>
    } @else {
      <div class="circle zero-surface primary-400">
        <web-design-system-icon name="star" color="white" />
      </div>
    }
    <div>
      <div class="zero-text p-base-med">{{ 'guided-tour.teaser.next.watchlist.headline' | transloco }}</div>
      <div class="zero-text p-small-reg">
        <a class="zero-text link" [routerLink]="WATCHLIST_URL">{{ 'guided-tour.teaser.next.watchlist.link' | transloco }}</a>
        {{ 'guided-tour.teaser.next.watchlist.text' | transloco }}
      </div>
    </div>
  </div>
  <div class="d-flex gap mb-3">
    @if (investmentStrategyStore.notedStrategy()) {
      <div class="circle zero-surface secondary-500">
        <web-design-system-icon name="check" color="white" />
      </div>
    } @else {
      <div class="circle zero-surface primary-400">
        <web-design-system-icon name="chess" color="white" />
      </div>
    }
    <div>
      @if (investmentStrategyStore.notedStrategy()) {
        <div class="zero-text p-base-med">{{ 'guided-tour.teaser.next.investment-strategy.noted.headline' | transloco }}</div>
        <div class="zero-text p-small-reg">
          {{ 'guided-tour.teaser.next.investment-strategy.noted.text' | transloco }}
          <a class="zero-text link" [routerLink]="INVESTMENT_STRATEGY_URL">{{
            'guided-tour.teaser.next.investment-strategy.noted.link' | transloco
          }}</a>
        </div>
      } @else {
        <div class="zero-text p-base-med">{{ 'guided-tour.teaser.next.investment-strategy.headline' | transloco }}</div>
        <div class="zero-text p-small-reg">
          {{ 'guided-tour.teaser.next.investment-strategy.text-prefix' | transloco }}
          <a class="zero-text link" [routerLink]="INVESTMENT_STRATEGY_URL">{{
            'guided-tour.teaser.next.investment-strategy.link' | transloco
          }}</a>
          {{ 'guided-tour.teaser.next.investment-strategy.text-suffix' | transloco }}
        </div>
      }
    </div>
  </div>
  <div class="d-flex gap mb-3 disabled">
    <div class="circle zero-surface grey-700">
      <web-design-system-icon name="debit" />
    </div>
    <div>
      <div class="zero-text p-base-med d-block d-lg-flex gap-half align-items-center">
        {{ 'guided-tour.teaser.next.money.headline' | transloco }}
        <ng-container *ngTemplateOutlet="afterOpeningTag" />
      </div>
      <div class="zero-text p-small-reg" [innerHTML]="'guided-tour.teaser.next.money.text' | transloco"></div>
    </div>
  </div>
  <div class="d-flex gap disabled">
    <div class="circle zero-surface grey-700">
      <web-design-system-icon name="add" />
    </div>
    <div>
      <div class="zero-text p-base-med d-block d-lg-flex gap-half align-items-center">
        {{ 'guided-tour.teaser.next.trade.headline' | transloco }}
        <ng-container *ngTemplateOutlet="afterOpeningTag" />
      </div>
      <div class="zero-text p-small-reg" [innerHTML]="'guided-tour.teaser.next.trade.text' | transloco"></div>
    </div>
  </div>
</div>

<ng-template #afterOpeningTag>
  <div class="zero-surface pink-500 zero-text p-small-reg white tag mt-1 mb-2 mt-lg-0 mb-lg-0">
    {{ 'guided-tour.teaser.next.after-opening-tag' | transloco }}
  </div>
</ng-template>
